import React from 'react';
import { FaDownload } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Navbar = () => {
  const handleBar = () => {
    // Gets the Mobile Nav icon by its ID
    const open = document.getElementById('bars').classList.toggle('fa-times');
    // Gets the Mobile Nav container
    document.getElementById('mobileMenu').classList.toggle('hidden');

    open.addEventListener('click', function () {
      document.getElementById('mobileMenu').classList.toggle('hidden');

    })


    // Displays the Mobile Nav when clicked and changes the Nav Icon from three bars to an 'X'


  }
  return (
    <div>
      <nav class="p-4  text-gray-200 w-full z-50 bg-gradient-to-r from-violet-800 via-blue-500 to-violet-600 top-0 fixed">
        <div class="flex justify-between items-center">
          <div class="flex items-center pl-0 md:pl-7 ">
            <div className="md:max-w-md lg:col-span-2">
              <a
                href="/"
                aria-label="Go home"
                title="Company"
                className="inline-flex items-center"
              >
                <svg
                  className="w-8 text-teal-accent-400"
                  viewBox="0 0 24 24"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  stroke="currentColor"
                  fill="none"
                >
                  <rect x="3" y="1" width="7" height="12" />
                  <rect x="3" y="17" width="7" height="6" />
                  <rect x="14" y="1" width="7" height="6" />
                  <rect x="14" y="11" width="7" height="12" />
                </svg>
                <span className="ml-2 text-xl font-bold tracking-wide text-gray-100 uppercase">
                  Crazy Shomik
                </span>
              </a>

            </div>
          </div>

          {/* <!-- MOBILE NAV ICON --> */}
          <div class="md:hidden block absolute top-4 right-8 fixed">
            <button aria-label="navigation" type="button" class="md:hidden text-gray-200 transition duration-300 focus:outline-none focus:text-white hover:text-white"><i class="fas fa-bars text-3xl" onClick={handleBar} id="bars"></i>            </button>
          </div>

          {/* <!-- NAVIGATION - LARGE SCREENS --> */}
          <div class="hidden md:flex">
            <ul class="hidden md:flex">
              <li class="text-lg pr-8 "><a href="" class="transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}> 
              <HashLink smooth to='/#Home'>Home</HashLink> </a></li>
              <li class="text-lg pr-8"><a href="" class="transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}> <HashLink smooth to='/#about'>About</HashLink></a></li>
              <li class="text-lg pr-8"><a href="" class="transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}> <HashLink smooth to='/#skill'>Skill</HashLink></a></li>
              <li class="text-lg pr-8"><a href="" class="transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}>
               <HashLink smooth to='/#blog'>Blog</HashLink> </a></li>
              <li class="text-lg pr-8"><a href="" class="transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}>
              <HashLink smooth to='/#contact'>Contact</HashLink></a></li>
              <li class="text-lg pr-8"><a href="https://drive.google.com/file/d/1D_qd5eSNApEfza6L3JX3M97j-XqkYm5P/view?usp=drivesdk" target='_blank ' class="transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}>
               Resume <FaDownload className='w-3 h-3 text-white  hover:text-yellow-500 inline ml-1'></FaDownload> </a></li>
            </ul>
          </div>

          <div class="hidden md:flex">
            <a href="https://www.facebook.com/crazyhridoyy" target='_blank ' ><i class="fab fa-facebook text-2xl pr-8 transition duration-300 focus:text-yellow-500 hover:text-yellow-500"></i></a>
            <a href="#"><i class="fab fa-linkedin text-2xl pr-8 transition duration-300 focus:text-yellow-500 hover:text-yellow-500"></i></a>
            <a href="https://m.me/crazyshomik" target='_blank '><i class="fab fa-facebook-messenger text-2xl pr-8 transition duration-300 focus:text-yellow-500 hover:text-yellow-500"></i></a>
            <a href="https://www.instagram.com/crazy_shomik/?fbclid=IwAR0yqzfV2cSEjl3k9uODquJjZxrKClnfGHYGrDP_hvCEVEJ4D8QWAZHqG7c" target='_blank '><i class="fab fa-instagram text-2xl pr-8 transition duration-300 focus:text-yellow-500 hover:text-yellow-500"></i></a>
            <a href="#"><i class="fab fa-twitter text-2xl pr-8 transition duration-300 focus:text-yellow-500 hover:text-yellow-500"></i></a>
          </div>
        </div>

        {/* <!-- MOBILE MENU --> */}
        <div id="mobileMenu" class=" hidden flex w-full mx-auto py-8 text-center">
          <div class="flex flex-col justify-center items-center w-full">
            <a href="#" class="block text-gray-200 cursor-pointer py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}> <HashLink smooth to='/#Home'>Home</HashLink></a>
            <a href=" " class="block text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}>
              <Link to='/about'> <HashLink smooth to='/#about'>About</HashLink></Link></a>
            <a href=" " class="block text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}>
            <HashLink smooth to='/#skill'>Skill</HashLink> </a>
            <a href="#" class="block text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}> <HashLink smooth to='/#blog'>Blog</HashLink> </a>
            <a href="#" class="block text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}> <HashLink smooth to='/#contact'>Contact</HashLink></a>
            <a href="https://drive.google.com/file/d/1D_qd5eSNApEfza6L3JX3M97j-XqkYm5P/view?usp=drivesdk" target='_blank ' class="block text-white w-32 md:w-28 bg-gradient-to-br from-purple-800 to-blue-800 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 text-gray-200 cursor-pointer mt-1 py-3 transition duration-300 focus:outline-none focus:text-yellow-500 focus:underline hover:underline hover:text-yellow-500" style={{ textUnderlineOffset: "8px;" }}>  Resume  <FaDownload className='w-3 h-3 text-white inline ml-1 mb-1  hover:text-yellow-500'></FaDownload> </a>
          </div>
        </div>
      </nav>

    </div>
  );
};

export default Navbar;